var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCommunities(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8099 9.87891H16.2002C16.3643 10.3281 16.4539 10.8129 16.4539 11.3182V17.4019C16.4539 17.6125 16.4172 17.8147 16.3505 18.0028H19.0117C20.0058 18.0028 20.8145 17.194 20.8145 16.2V12.8835C20.8145 11.2268 19.4666 9.87891 17.8099 9.87891Z",
    fill: "#706D9D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.36062 11.3182C4.36062 10.8129 4.45026 10.3281 4.61433 9.87891H3.00465C1.34788 9.87891 0 11.2268 0 12.8836V16.2C0 17.1941 0.808706 18.0028 1.80279 18.0028H4.464C4.39729 17.8147 4.36062 17.6125 4.36062 17.4019V11.3182Z",
    fill: "#706D9D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2466 8.30762H8.56666C6.9099 8.30762 5.56201 9.6555 5.56201 11.3123V17.396C5.56201 17.7278 5.83105 17.9969 6.16294 17.9969H14.6503C14.9822 17.9969 15.2513 17.7278 15.2513 17.396V11.3123C15.2513 9.6555 13.9034 8.30762 12.2466 8.30762Z",
    fill: "#706D9D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4074 0.34375C8.41493 0.34375 6.79395 1.96474 6.79395 3.95725C6.79395 5.30875 7.53988 6.48911 8.64149 7.10882C9.164 7.40274 9.76639 7.57072 10.4074 7.57072C11.0484 7.57072 11.6508 7.40274 12.1733 7.10882C13.275 6.48911 14.0209 5.30871 14.0209 3.95725C14.0209 1.96478 12.3999 0.34375 10.4074 0.34375Z",
    fill: "#706D9D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.06128 3.70898C2.57115 3.70898 1.35889 4.92125 1.35889 6.41138C1.35889 7.9015 2.57115 9.11377 4.06128 9.11377C4.43927 9.11377 4.79921 9.03547 5.12618 8.89473C5.6915 8.65135 6.15762 8.22051 6.44605 7.68084C6.6485 7.30208 6.76367 6.86998 6.76367 6.41138C6.76367 4.92129 5.55141 3.70898 4.06128 3.70898Z",
    fill: "#706D9D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7522 3.70898C15.2621 3.70898 14.0498 4.92125 14.0498 6.41138C14.0498 6.87002 14.165 7.30212 14.3674 7.68084C14.6559 8.22055 15.122 8.65139 15.6873 8.89473C16.0143 9.03547 16.3742 9.11377 16.7522 9.11377C18.2423 9.11377 19.4546 7.9015 19.4546 6.41138C19.4546 4.92125 18.2423 3.70898 16.7522 3.70898Z",
    fill: "#706D9D"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunities);
export default __webpack_public_path__ + "static/media/communities.ef1dc6ab5ccdc9374a2e9c404f004f50.svg";
export { ForwardRef as ReactComponent };